import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";
import useAxios from '../../api/useAxios'

// axios.interceptors.response.use(function (response) {
//   return response;
// }, function (error) {
//   if (401 === error.response.status) {
//     localStorage.clear();
//     window.location.reload();
//   } else {
//     return Promise.reject(error);
//   }
// });

export const proposalCount = (cb) => {
  const uesrDetails = localStorage.getItem('userDetails') && JSON.parse(localStorage.getItem('userDetails')).user;
  return dispatch => {
    dispatch({ type: actionType.LOADER_TRUE });
    useAxios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/count?agentCode=${uesrDetails.code}&role=${uesrDetails.role}`, {

      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      }
    }).then((res) => {
      dispatch({ type: actionType.LOADER_FALSE })
      if (res.data.body) {
        localStorage.setItem("otpValues", JSON.stringify(res.data.body))
        dispatch({
          type: actionType.PROPOSAL_COUNT,
          proposalCount: res.data.body
        })
        if (cb) {
          cb();
        }
        toaster("success", res.data.message)
      } else {
        toaster("error", res.data.message)
      }

    }).catch(() => {
      dispatch({ type: actionType.LOADER_FALSE })
    })
  }
}

export const proposalCount2 = (cb) => {
  const uesrDetails = localStorage.getItem('userDetails') && JSON.parse(localStorage.getItem('userDetails')).user;
  return dispatch => {
    dispatch({ type: actionType.LOADER_TRUE });
      useAxios.get(`${apiConstants().DASHBOARD_API_URL}api/v1/tracker/count?agentCode=${uesrDetails.code}&role=${uesrDetails.role}`, {

      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      }
    }).then((res) => {
      dispatch({ type: actionType.LOADER_FALSE })
      if (res.data.body) {
        localStorage.setItem("otpValues", JSON.stringify(res.data.body))
        dispatch({
          type: actionType.PROPOSAL_COUNT,
          proposalCount: res.data.body
        })
        if (cb) {
          cb();
        }
        //toaster("success", res.data.message)
      } else {
        toaster("error", res.data.message)
      }

    }).catch(() => {
      dispatch({ type: actionType.LOADER_FALSE })
    })
  }
}
export const getSelectedProposalData2 = (dates,type) => {
  let apiUrl = '';
  // const uesrDetails = localStorage.getItem('userDetails') && JSON.parse(localStorage.getItem('userDetails')).user;
  apiUrl = `${apiConstants().DASHBOARD_API_URL}api/v1/tracker/fetchReport?${dates}`
  return dispatch => {
    dispatch({ type: actionType.LOADER_TRUE });
    axios.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      }
    }).then((res) => {
      dispatch({ type: actionType.LOADER_FALSE })
      if (res.data.body) {
        dispatch({
          type: actionType.SELECTED_PROPOSALS,
          selectedProposals: res.data.body.itemList,
          selectedType: type
        })
        //toaster("success", res.data.message)
      } else {
        toaster("error", res.data.message)
      }
    }).catch(() => {
      dispatch({ type: actionType.LOADER_FALSE })
      dispatch({
        type: actionType.SELECTED_PROPOSALS,
        selectedProposals: [],
        selectedType: type
      })
    })
  }
}
export const getSelectedProposalData = (type, custom) => {
  let apiUrl = '';
  const uesrDetails = localStorage.getItem('userDetails') && JSON.parse(localStorage.getItem('userDetails')).user;
  if (custom) {
    apiUrl = `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/data/?${type}&agentCode=${uesrDetails.code}&role=${uesrDetails.role}`
  }
  else {
    apiUrl = `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/data/${type}?agentCode=${uesrDetails.code}&role=${uesrDetails.role}`
  }
  return dispatch => {
    dispatch({ type: actionType.LOADER_TRUE });
    axios.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      }
    }).then((res) => {
      dispatch({ type: actionType.LOADER_FALSE })
      if (res.data.body) {
        dispatch({
          type: actionType.SELECTED_PROPOSALS,
          selectedProposals: res.data.body,
          selectedType: type
        })
        toaster("success", res.data.message)
      } else {
        console.log(toaster, res.data.message);
        toaster("error", res.data.message)
      }
    }).catch(() => {
      dispatch({ type: actionType.LOADER_FALSE })
      dispatch({
        type: actionType.SELECTED_PROPOSALS,
        selectedProposals: [],
        selectedType: type
      })
    })
  }
}

export const changeType = (type) => {
  return dispatch => {
    dispatch({
      type: actionType.CHANGE_SELECTION,
      selectedType: type
    });
  }
}

export const getPaymentMethodData = (pn) => async (dispatch) => {
  try {
    const {data} = await axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/payment/data?proposalNo=${pn}`, {
      headers: {
        authorization: localStorage.getItem("token"),
      }
    })
    dispatch({
      type: actionType.PAYMENT_METHOD_LIST,
      payload: data ? data.split(",") : "No Data"
    })
  } catch (err) {
    console.log(`err`, err)
  }
}

export const resetPaymentMethod = () => async (dispatch) => {
  dispatch({
    type: actionType.PAYMENT_METHOD_LIST,
    payload: []
  })
}




